"use strict";

require("core-js/modules/es.symbol");
require("core-js/modules/es.array.index-of");
require("core-js/modules/es.object.assign");
require("core-js/modules/es.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _styledSystem = require("styled-system");
var _primitives = require("../primitives");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

// Allows you to set a gradient as the background
var backgroundGradient = (0, _styledSystem.style)({
  prop: 'backgroundGradient',
  key: 'gradients',
  cssProperty: 'background-image'
});
var GradientCard = (0, _styledComponents.default)(_primitives.Card).withConfig({
  displayName: "FancyCard__GradientCard",
  componentId: "sc-1b1qazu-0"
})(backgroundGradient);
var _StyledCard = (0, _styledComponents.default)(_primitives.Card).withConfig({
  displayName: "FancyCard___StyledCard",
  componentId: "sc-1b1qazu-1"
})(["background-clip:padding-box;"]);
var FancyCard = function FancyCard(_ref) {
  var alignSelf = _ref.alignSelf,
    backgroundGradient = _ref.backgroundGradient,
    borderRadius = _ref.borderRadius,
    m = _ref.m,
    mt = _ref.mt,
    mr = _ref.mr,
    mb = _ref.mb,
    ml = _ref.ml,
    mx = _ref.mx,
    my = _ref.my,
    others = _objectWithoutProperties(_ref, ["alignSelf", "backgroundGradient", "borderRadius", "m", "mt", "mr", "mb", "ml", "mx", "my"]);
  var outerProps = {
    alignSelf: alignSelf,
    backgroundGradient: backgroundGradient,
    borderRadius: borderRadius,
    m: m,
    mt: mt,
    mr: mr,
    mb: mb,
    ml: ml,
    mx: mx,
    my: my
  };
  return /*#__PURE__*/_react.default.createElement(GradientCard, outerProps, /*#__PURE__*/_react.default.createElement(_StyledCard, _extends({
    borderRadius: borderRadius,
    border: "2.1px solid transparent"
  }, others)));
};
FancyCard.defaultProps = {
  bg: 'white',
  borderRadius: 'lg'
};
FancyCard.propTypes = {};
var _default = FancyCard;
exports.default = _default;